import React from "react";
import { useLoading } from "../../hooks/useLoading";
import styles from "./GlobalLoader.module.css";
import KropkiLadowania from "../common/Ladowanie/KropkiLadowania";
import PasekPostepu from "../common/Ladowanie/PasekPostepu";
import LicznikCzasu from "../common/Ladowanie/LicznikCzasu";
import { OPOZNIENIE_LICZNIKA_MS, useUplywCzasu } from "../common/Ladowanie/czasLadowania";

/*
 * [S19 2026-09-14] GLOBALNY WSKAŹNIK ŁADOWANIA — smukły pasek u góry + pigułka „kropki · Ładowanie… · 1,2 s”.
 *
 * BYŁO: pełnoekranowa nakładka z rozmyciem (backdrop-filter 6 px) i trzema kręcącymi się pierścieniami. Każde
 * `showLoader()` z ~45 ekranów zasłaniało i BLOKOWAŁO całą aplikację; właściciel: „totalnie brzydkie, to ma być
 * coś smukłego biznesowego”.
 * JEST: wskaźnik INFORMUJE i nie łapie kliknięć. Pigułka i czas pojawiają się po OPOZNIENIE_LICZNIKA_MS, żeby
 * szybkie zapytania nie migały. Blokada klikania wyłącznie na jawne życzenie ekranu: `showLoader({ blokuj: true })`.
 * Ścieżka i domyślny eksport bez zmian — mockuje je kilka plików testów.
 */
const GlobalLoader = () => {
  const { isLoading, blokuje, startedAt } = useLoading();
  const uplyw = useUplywCzasu(isLoading ? startedAt : null);
  const widoczna = isLoading && uplyw >= OPOZNIENIE_LICZNIKA_MS;

  return (
    <>
      <PasekPostepu aktywny={isLoading} uplywMs={uplyw} przyklejony />
      {isLoading && (
        <div
          className={`${styles.pigulka} ${widoczna ? styles.widoczna : ""}`}
          role="status"
          aria-live="polite"
          data-globalny-wskaznik=""
        >
          {widoczna && (
            <>
              <KropkiLadowania rozmiar="sm" ozdobne />
              <span className={styles.napis}>Ładowanie…</span>
              <LicznikCzasu uplywMs={uplyw} className={styles.czas} />
            </>
          )}
        </div>
      )}
      {isLoading && blokuje && (
        <div className={styles.blokada} data-blokada-ladowania="" aria-hidden="true" />
      )}
    </>
  );
};

export default GlobalLoader;
